import { ChartInfoKind } from '@frontend/chart/types';
import { LuTrendingDown } from 'react-icons/lu';
import { FormattedMessage } from 'react-intl';

import { StatisticsCard } from '../../shared';
import { VendingProductPopularityItem, formatVendingPopularityTrendChange } from '../vending-product-popularity';

export interface Last60DaysVendingLowestFallerMetricCardProps {
    item: VendingProductPopularityItem | null;
    isLoading: boolean;
}

export const Last60DaysVendingLowestFallerMetricCard = ({ item, isLoading }: Last60DaysVendingLowestFallerMetricCardProps) => (
    <StatisticsCard
        infoKind={ChartInfoKind.PERIOD_CHANGE_METRIC}
        compact
        title={
            <FormattedMessage
                id='platform.statistics.vending.last-60-days-vending-lowest-faller-metric-card.title'
                description='Title of the vending dashboard card showing the product with the largest month-over-month consumption decrease'
                defaultMessage='Lowest faller'
            />
        }
        subtitle={
            <FormattedMessage
                id='platform.statistics.pudo.last-60-days-pudo-timer-duration-metric-chart-card.subtitle'
                description='Subtitle on PuDo dashboard cards comparing average drop-off or pick-up time to the previous month'
                defaultMessage='Compared to last month'
            />
        }
        isLoading={isLoading}
        hasData={item !== null}>
        {item && (
            <div className='mt-auto flex w-full items-end justify-between gap-3'>
                <div className='text-foreground-default min-w-0 truncate text-lg font-semibold'>{item.name}</div>
                <div className='text-status-warning flex shrink-0 items-center gap-1 text-sm font-semibold'>
                    <LuTrendingDown className='size-4' />
                    {formatVendingPopularityTrendChange(item)}
                </div>
            </div>
        )}
    </StatisticsCard>
);
